import { ActivatedRoute, Router } from '@angular/router';
import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'app/services/auth.service';

declare var $: any;

@Component({
  selector: 'app-send-cmanotification',
  templateUrl: './send-cmanotification.component.html',
  styleUrls: ['./send-cmanotification.component.css'],
})
export class SendCMANotificationComponent implements OnInit {
  cmaOfficerName: any;
  cmaCompanyName: any;
  cmaDatetime: string;
  cmaDateFrom: string;
  cmaDateTo: string;
  valMsgSendCmaOName: boolean = false;
  valMsgSendCmaCName: boolean = false;
  valMsgDateTime: boolean = false;
  valMsgDateFrom: boolean = false;
  valMsgDateTo: boolean = false;
  valMsgInvalidDateFrom: boolean = false;
  valMsgInvalidDateTo: boolean = false;
  showStepErrMsg: boolean = false;
  aId: string;
  uId: string = '';
  cma: any;
  dataRec: boolean = false;
  user: any;

  constructor(
    private auth: AuthService,
    private lservice: LoanappService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.aId = params['id'];
      this.uId = params['uId'];
    });
  }

  ngOnInit() {
    this.user = this.auth.user;
    this.getAllCma();
  }

  getAllCma() {
    this.lservice.getAllCma().subscribe(
      (data) => {
        this.dataRec = true;
        console.log(data);
        if (data['success']) {
          this.cma = data['data'];
        }
      },
      (err) => {
        this.toastr.error('Error occurred. Please try again.');
        $('#error').modal('show');
      }
    );
  }
  goBack() {
    window.location.href =
      '/loanapplicationdetails?id=' + this.aId + '&uId=' + this.uId;
  }

  send() {
    this.showStepErrMsg = false;
    this.valMsgSendCmaOName = false;
    this.valMsgSendCmaCName = false;
    this.valMsgDateTime = false;
    this.valMsgDateFrom = false;
    this.valMsgDateTo = false;
    this.valMsgInvalidDateFrom = false;
    this.valMsgInvalidDateTo = false;

    if (this.cmaOfficerName) {
      this.cmaOfficerName = this.cmaOfficerName.trim();
    }

    if (!this.cmaOfficerName) {
      this.valMsgSendCmaOName = true;
    }
    if (!this.cmaCompanyName) {
      this.valMsgSendCmaCName = true;
    }

    if (!this.cmaDateFrom) {
      this.valMsgDateFrom = true;
    }

    if (!this.cmaDateTo) {
      this.valMsgDateTo = true;
    }

    if (
      !this.cmaOfficerName ||
      !this.cmaDateFrom ||
      !this.cmaDateTo ||
      !this.cmaCompanyName
    ) {
      return;
    }

    const dateRegex = new RegExp(/\b[0-9]{4}-[0-9]{2}-[0-9]{2}\b/);
    if (!dateRegex.test(this.cmaDateFrom)) this.valMsgInvalidDateFrom = true;
    if (!dateRegex.test(this.cmaDateTo)) this.valMsgInvalidDateTo = true;

    if (this.valMsgInvalidDateFrom || this.valMsgInvalidDateTo) return;

    $('#send').modal('show');
  }

  cancel() {
    $('#send').modal('hide');
  }
  cancelS() {
    window.location.href =
      '/loanapplicationdetails?id=' + this.aId + '&uId=' + this.uId;
  }

  stringify(o: any): string {
    return JSON.stringify(o);
  }

  sendNow() {
    if (!this.send) {
      this.showStepErrMsg = true;
      return false;
    }

    let h = JSON.parse(this.cmaCompanyName);
    let obj = {
      cmaId: h['_id'],
      cmaCompanyName: h['companyName'],
      cmaOfficerName: this.cmaOfficerName,
      cmaAuditStart: this.cmaDateFrom,
      cmaAuditEnd: this.cmaDateTo,
      aId: this.aId,
    };

    this.lservice.sendNotification(obj).subscribe(
      (data) => {
        console.log(data);
        if (data['success']) {
          $('#send').modal('hide');
          $('#sent').modal('show');
          setTimeout(() => {
            window.location.href =
              '/loanapplicationdetails?id=' + this.aId + '&uId=' + this.uId;
          }, 2000);
        }
      },
      (err) => {
        console.log(err, 'ERROR occurred');
        this.toastr.error('ERROR occurred. Please try again.');
        $('#error').modal('show');
      }
    );
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
